<template>
    <footer class="site-footer footer-dark">
      <div class="footer-main">
        <div class="container">
          <div class="row">
            <!-- Manzil / kontaktlar -->
            <div class="col-xl-3 col-md-5">
              <div class="widget widget-address-info">
                <h5 class="widget-title">Where To Find Us</h5>
                <ul class="address-info-list">
                  <!-- Agar kerak bo'lsa address qatorini keyin ochasiz -->
                  <!--
                  <li>
                    <i class="icon">
                      <img
                        class="img-fluid"
                        src="/assets/images/svg/address-info-contacts.svg"
                        alt=""
                      />
                    </i>
                    <span class="info">
                      <span>17504 Carlton Cuevas Rd </span>Gulfport, MS, 39503
                    </span>
                  </li>
                  -->
                  <li>
                    <i class="icon">
                      <img
                        class="img-fluid"
                        src="/assets/images/svg/address-info-headphone.svg"
                        alt=""
                      />
                    </i>
                    <span class="info">
                      <span>+998 99 008 54 98 </span>Mon–Fri 8:30am – 6:30pm
                    </span>
                  </li>
                  <li>
                    <i class="icon">
                      <img
                        class="img-fluid"
                        src="/assets/images/svg/address-info-email.svg"
                        alt=""
                      />
                    </i>
                    <span class="info">
                      <span>husenovabdullo@gmail.com </span>24x7 online support
                    </span>
                  </li>
                </ul>
              </div>
            </div>
  
            <!-- Newsletter -->
            <div class="col-xl-5 col-md-7">
              <div class="widget">
                <h5 class="widget-title">Newsletter</h5>
                <div class="widget widget-newsletter mb-4 pb-2">
                  <form class="newsletter-form">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Your Email"
                    />
                    <button type="submit" class="subscribe-btn">
                      <i class="fa-solid fa-paper-plane"></i>
                    </button>
                  </form>
                </div>
  
                <!-- Quick Links kerak bo'lsa keyin ochasiz -->
                <!--
                <div class="widget widget-menu">
                  <h6 class="widget-title">Quick Links</h6>
                  <ul class="list-unstyled list-col-3 mb-0">
                    <li><a href="index.html">Home</a></li>
                    <li><a href="about-us.html">About us</a></li>
                    <li><a href="team.html">Team</a></li>
                    <li><a href="team-single.html">Team Single</a></li>
                    <li><a href="service.html">Service</a></li>
                    <li><a href="service-detail.html">Service Single</a></li>
                    <li><a href="blog.html">Blog</a></li>
                    <li><a href="blog-detail.html">Blog Single</a></li>
                    <li><a href="contact-us.html">Contact</a></li>
                  </ul>
                </div>
                -->
              </div>
            </div>
  
            <!-- Call center + social -->
            <div class="col-xl-3 col-md-12 ms-auto">
              <div class="widget widget-info">
                <h5 class="widget-title">Call Center</h5>
                <a class="number" href="tel:+998990085498">+998 99 008 54 98</a>
                <h6 class="title">and get a free estimate</h6>
              </div>
  
              <div class="widget-socail">
                <ul class="socail-icon">
                  <li>
                    <a href="#" aria-label="Facebook">
                      <i class="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" aria-label="Telegram">
                      <i class="fa-brands fa-telegram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" aria-label="LinkedIn">
                      <i class="fa-brands fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" aria-label="Behance">
                      <i class="fa-brands fa-behance"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
  
        </div>
      </div>
  
      <!-- Pastki qism: NextLine.uz logosi -->
      <div class="footer-copyright">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <p>
                <a class="footer-logo brand-logo" href="https://nextline.uz/">
                  <span class="brand-icon">
                    <span class="brand-icon-box left"></span>
                    <span class="brand-icon-box right"></span>
                  </span>
  
                  <span class="brand-text">
                    <span class="brand-next">Next</span>
                    <span class="brand-line">Line</span>
                    <span class="brand-dot">.uz</span>
                  </span>
                </a>
              </p>
            </div>
            <div class="col-lg-6 text-lg-end">
              <p>
                Develop and design by
                <a href="https://nextline.uz" target="_blank" rel="noopener">
                  NextLine.uz
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </template>
  
  <style scoped>
  /* Footer ichidagi NextLine.uz matnli logo – header logosi bilan bir xil uslubda */
  
  .brand-logo {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
  }
  
  .brand-icon {
    display: inline-flex;
    gap: 6px;
    align-items: center;
  }
  
  .brand-icon-box {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    border: 2px solid #3b82f6;
    box-shadow: 0 0 10px rgba(59, 130, 246, 0.6);
  }
  
  .brand-icon-box.left {
    border-right: none;
    transform: skewX(-15deg);
  }
  
  .brand-icon-box.right {
    border-left: none;
    transform: skewX(15deg);
  }
  
  .brand-text {
    font-family: 'Poppins', system-ui, -apple-system, BlinkMacSystemFont,
      'Segoe UI', sans-serif;
    display: inline-flex;
    align-items: baseline;
    font-weight: 700;
    letter-spacing: 0.04em;
    font-size: 22px;
  }
  
  .brand-next {
    color: #ffffff;
  }
  
  .brand-line {
    margin-left: 4px;
    background: linear-gradient(90deg, #22d3ee, #3b82f6);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  
  .brand-dot {
    margin-left: 2px;
    font-weight: 500;
    font-size: 16px;
    color: #9ca3af;
  }
  
  /* Kichik ekranlarda moslashuvi */
  @media (max-width: 991.98px) {
    .brand-text {
      font-size: 18px;
    }
  
    .brand-dot {
      font-size: 14px;
    }
  
    .brand-icon-box {
      width: 20px;
      height: 20px;
    }
  }
  </style>
  